import { NgModule } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EffectsModule } from '@ngrx/effects';
import {
  RouterStateSerializer,
  StoreRouterConnectingModule,
} from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { RootEffects } from './root-store.effects';
import { CustomSerializer, metaReducers, reducers } from './root-store.reducer';

const devMiddleware = [];

if (!environment.production) {
  devMiddleware.push(StoreDevtoolsModule.instrument());
}
@NgModule({
  imports: [
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([RootEffects]),
    StoreRouterConnectingModule.forRoot(),
    ...devMiddleware,
  ],
  exports: [StoreModule],
  providers: [
    {
      provide: RouterStateSerializer,
      useClass: CustomSerializer,
    },
  ],
})
export class RootStoreModule {}
